import { columns } from "../../../../dtos/columns";
import AccionesAnalizador from "../components/accionesAnalizador";
import { DatosTotalesDto } from "../models/resumenesTotales";

export function useColumnsResumenTotales() {
  const COLUMNS: columns<DatosTotalesDto>[] = [
    {
      name: "",
      selector: (row: DatosTotalesDto) => row.key,
      sortable: false,
      wrap: true,
      export: true,
      alling: 'left',
    },
    {
      name: "Débitos",
      selector: (row: DatosTotalesDto) => row.debito || 0,
      sortable: false,
      wrap: true,
      export: true,
      alling: 'center'
    },
    {
      name: "Créditos",
      selector: (row: DatosTotalesDto) => row.credito || 0,
      sortable: false,
      wrap: true,
      export: true,
      alling: 'center'
    },
    {
      name: 'Acciones',
      selector: (row: DatosTotalesDto) => '',
      cell: (row: DatosTotalesDto) => row.key !== 'Totales' && <AccionesAnalizador datoTotal={row} />,
      allowOverflow: true,
      button: true,
      export: false,
    },
  ]

  return { COLUMNS };
}